import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import CheckboxGroupDemo from './checkbox-group-demo';
import CheckboxNogroupDemo from './checkbox-nogroup-demo';

import Arranger from '~c/components/base/arranger';

interface Props {
  className?: string;
}

const CheckboxDemo: React.FC<Props> = ({ className }) => {
  return (
    <Arranger className={className} alignItems="flex-start">
      <CheckboxGroupDemo />
      <CheckboxNogroupDemo />
    </Arranger>
  );
};

export default muiStyled(CheckboxDemo)(({ theme }) => css``);
